import React, { createContext, useContext, useEffect, ReactNode } from 'react';

interface TikTokPixelContextType {
  track: (event: string, properties?: Record<string, any>) => void;
  identify: (properties: Record<string, any>) => void;
  pageView: () => void;
}

const TikTokPixelContext = createContext<TikTokPixelContextType | undefined>(undefined);

interface TikTokPixelProviderProps {
  children: ReactNode;
  enabled?: boolean;
}

// Расширяем глобальный объект window для TikTok Pixel
declare global {
  interface Window {
    ttq: {
      load: (pixelId: string) => void;
      page: () => void;
      track: (event: string, properties?: Record<string, any>) => void;
      identify: (properties: Record<string, any>) => void;
      _i: any[];
      _o: Record<string, any>;
    };
  }
}

export const TikTokPixelProvider: React.FC<TikTokPixelProviderProps> = ({ 
  children, 
  enabled = true 
}) => {

  const track = (event: string, properties?: Record<string, any>) => {
    if (!enabled || !window.ttq) {
      console.warn('TikTok Pixel not initialized');
      return;
    }

    try {
      window.ttq.track(event, properties);
      console.log('TikTok Pixel tracked event:', event, properties);
    } catch (error) {
      console.error('TikTok Pixel tracking error:', error);
    }
  };

  const identify = (properties: Record<string, any>) => {
    if (!enabled || !window.ttq) {
      console.warn('TikTok Pixel not initialized');
      return;
    }

    try {
      window.ttq.identify(properties);
      console.log('TikTok Pixel identify:', properties);
    } catch (error) {
      console.error('TikTok Pixel identify error:', error);
    }
  };

  const pageView = () => {
    if (!enabled || !window.ttq) {
      console.warn('TikTok Pixel not initialized');
      return;
    }

    try {
      window.ttq.page();
      console.log('TikTok Pixel page view tracked');
    } catch (error) {
      console.error('TikTok Pixel page view error:', error);
    }
  };

  return (
    <TikTokPixelContext.Provider value={{ track, identify, pageView }}>
      {children}
    </TikTokPixelContext.Provider>
  );
};


export const useTikTokPixel = () => {
  const context = useContext(TikTokPixelContext);
  if (context === undefined) {
    throw new Error('useTikTokPixel must be used within a TikTokPixelProvider');
  }
  return context;
};
